import BfvImage from '../BfvImage';
import { CONFIG } from '../config';

class BfvGalleryLightboxImage extends BfvImage {
  constructor(options = {}) {
    super(options);
  }

  /**
   * OVERRIDES
   */

  /**
   * We need our own lightbox scroll event, since we are on a fixed layer
   */
  init() {
    this.prepareDOM();
    this.bindEvents();

    if (!this.disableAutoLoad) {
      // dynamically load image on scroll
      setTimeout(() => this.loadImageVisibleInViewport(this.getLightboxScroll()), 200);
    }
  }

  /**
   * EVENT HANDLING OVERRIDE
   */

  /**
   * We need our own lightbox scroll event, since we are on a fixed layer
   */
  bindEvents() {
    /* eslint-disable no-unused-vars */
    window.addEventListener(CONFIG.events.LIGHTBOX_SCROLL, (event) => {
      this.loadImageVisibleInViewport(this.getLightboxScroll());
    });

    window.addEventListener(CONFIG.events.VIEWPORT_CHANGED, (event) => {
      this.targetAsset = this.getTargetImageAsset(this.currentBreakpointKey);
      this.stateLoading = this.LOAD_INIT;
      this.loadImageVisibleInViewport(this.getLightboxScroll());
    });
    /* eslint-disable no-unused-vars */
  }

  /**
   * Our own Scroll event
   * @returns {{x: number, y: number}} with 'x' and 'y' scroll position of the lightbox
   */
  getLightboxScroll() {
    const rootBoundingClientRect = this.$root.getBoundingClientRect();
    const wrapperBoundingClientRect = this.$root.closest('.js-scroll-viewbox') ? this.$root.closest('.js-scroll-viewbox').getBoundingClientRect() : '';
    // IE 11 does not know .x and .y so use .left and .top instead
    return {
      x: rootBoundingClientRect.x || rootBoundingClientRect.left,
      y: (rootBoundingClientRect.y || rootBoundingClientRect.top) -
      (wrapperBoundingClientRect.y || wrapperBoundingClientRect.top),
    };
  }
}

export default BfvGalleryLightboxImage;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvGalleryLightboxImage/index.js